import React from "react";
import { Locale } from "inbox-contentful";
import { useEffect, useRef, useState } from "react";
import { getLocalizedShortenedNumber } from "inbox-contentful/src/localizedShortenedNumber";

export function RawValue({
    lang,
    trackerProgress,
    trackerProgressRef,
}: {
    lang: string;
    trackerProgress?: number;
    trackerProgressRef: React.RefObject<HTMLDivElement | null>;
}) {
    const ref = useRef<HTMLDivElement>(null);
    const [fitsLeft, setFitsLeft] = useState<boolean>(false);

    useEffect(() => {
        setTimeout(() => {
            if (!ref.current || !trackerProgressRef.current) return;

            setFitsLeft(
                ref.current.clientWidth + 20 <
                    trackerProgressRef.current.clientWidth,
            );
        }, 1100);

        setTimeout(() => {
            if (!ref.current || !trackerProgressRef.current) return;

            setFitsLeft(
                ref.current.clientWidth + 20 <
                    trackerProgressRef.current.clientWidth,
            );
        }, 2000);
    }, [trackerProgressRef.current, trackerProgress]);

    if (!trackerProgress) return null;

    let { data: locale, error } = Locale.safeParse(lang);
    if (error || locale === undefined) {
        console.error(`Invalid locale passed to RawValue: ${lang}`);
        locale = "en";
    }

    return (
        <div
            className="rawValue"
            ref={ref}
            style={{
                left: !fitsLeft ? "calc(100% + 1.4rem)" : "0.6rem",
            }}
        >
            <div className="rawValueText">
                {getLocalizedShortenedNumber(
                    trackerProgress * 1_000_000,
                    locale,
                )}
            </div>
        </div>
    );
}
